var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7695,
    cy: 12.2812,
    r: 11.5,
    stroke: "#CED0D4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3045_13481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1695 6.68094C14.8495 6.68094 16.4495 7.32094 17.6495 8.52094C20.1295 11.0009 20.1295 15.0809 17.6495 17.5609C16.2095 19.0809 14.2095 19.6409 12.2895 19.4009L12.6895 17.8009C14.0495 17.9609 15.4895 17.4809 16.5295 16.4409C18.3695 14.6009 18.3695 11.5609 16.5295 9.64094C15.6495 8.76094 14.3695 8.28094 13.1695 8.28094V11.9609L9.16951 7.96094L13.1695 3.96094V6.68094ZM8.60951 17.5609C6.52951 15.4809 6.20951 12.2809 7.64951 9.80094L8.84951 11.0009C7.96951 12.7609 8.28951 15.0009 9.80951 16.4409C10.2095 16.8409 10.6895 17.1609 11.2495 17.4009L10.7695 19.0009C9.96951 18.6809 9.24951 18.2009 8.60951 17.5609Z",
    fill: "#CED0D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3045_13481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(3.56958 3.48047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.bd4bf54e2e9c1b96078088cf173f7f5f.svg";
export { ForwardRef as ReactComponent };